module.exports = __webpack_public_path__ + "img/connect-2.b8c6c716.svg";